import { SCROLL_ELEMENTS } from '@/content/values/ed-presentation-mode.values';
import { MY_CONTENT_TYPES } from '@/app/private/my-content/values/my-content.values';

const PDF_CONTAINER_CLASS   : string = 'pdf-container';
const IMAGE_CONTAINER_CLASS : string = 'section-imagen';
const VIDEO_CONTAINER_CLASS : string = 'section-video';
const PPT_HTML_CONTAINER_CLASS : string = 'ppt-html';
const DECK_CARD_CONTAINER_CLASS : string = 'ed-deck-card__container';
const TEXT_CONTAINER_CLASS  : string = 'section-text';

export const SECTION_TYPE_CODES = {
    LESSON_PDF: 'LESSON_PDF',
    LESSON_DOC: 'LESSON_DOC',
    LESSON_DOCX: 'LESSON_DOCX',
    LESSON_XLS: 'LESSON_XLS',
    LESSON_XLSX: 'LESSON_XLSX',
    LESSON_PPT: 'LESSON_PPT',
    LESSON_PPTX: 'LESSON_PPTX',
    LESSON_VIDEO: 'LESSON_VIDEO',
    LESSON_IMAGES: 'LESSON_IMAGES',
    LESSON_TEXT: 'LESSON_TEXT',
    LESSON_MATERIAL: 'LESSON_MATERIAL',
    LESSON_SPLIT_WRITE: 'LESSON_SPLIT_WRITE',
    LESSON_SPLIT_TYPE: 'LESSON_SPLIT_TYPE',
    LESSON_EPUB: 'LESSON_EPUB',
    LESSON_PPT_HTML: 'LESSON_PPT_HTML',
    LESSON_CARD: 'LESSON_CARD'
};

export const CLASS_BY_OBJECT_TYPE = {
    [SECTION_TYPE_CODES.LESSON_TEXT]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_IMAGES]: SCROLL_ELEMENTS.images.className,
    [SECTION_TYPE_CODES.LESSON_SPLIT_TYPE]: SCROLL_ELEMENTS.responseType.className,
    [SECTION_TYPE_CODES.LESSON_SPLIT_WRITE]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_PDF]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_DOCX]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_XLS]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_XLSX]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_PPT]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_PPTX]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_DOC]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_MATERIAL]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_PPT_HTML]: 'ed-html-viewer',
    [SECTION_TYPE_CODES.LESSON_VIDEO]: 'ed-video-viewer',
    [MY_CONTENT_TYPES.BOOK]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_EPUB]: SCROLL_ELEMENTS.pdf.className,
    [SECTION_TYPE_CODES.LESSON_CARD]: SCROLL_ELEMENTS.deckCard.className,
}

export const SKIP_LOADED_PAGE_VERIFICATION_TYPES : string[] = [
    SECTION_TYPE_CODES.LESSON_SPLIT_TYPE,
    SECTION_TYPE_CODES.LESSON_CARD
];

export const RESIZE_TYPES : string[] = [
    SECTION_TYPE_CODES.LESSON_TEXT,
    SECTION_TYPE_CODES.LESSON_IMAGES,
    SECTION_TYPE_CODES.LESSON_VIDEO,
    SECTION_TYPE_CODES.LESSON_PDF,
    SECTION_TYPE_CODES.LESSON_PPT_HTML,
    SECTION_TYPE_CODES.LESSON_SPLIT_TYPE,
    SECTION_TYPE_CODES.LESSON_SPLIT_WRITE,
    SECTION_TYPE_CODES.LESSON_CARD,
];

export const SINGLE_BOARD_TYPES : string[] = [
    SECTION_TYPE_CODES.LESSON_VIDEO,
    SECTION_TYPE_CODES.LESSON_PPT_HTML
];

export const WBO_CURSOR_TYPES : string[] = [
    SECTION_TYPE_CODES.LESSON_CARD,
    SECTION_TYPE_CODES.LESSON_PPT_HTML
];

export const KEYBOARD_ARROWS_TYPES : string[] = [
    SECTION_TYPE_CODES.LESSON_PPT_HTML,
    SECTION_TYPE_CODES.LESSON_CARD,
];

export const SPLIT_TYPES : string[] = [
    SECTION_TYPE_CODES.LESSON_SPLIT_WRITE,
    SECTION_TYPE_CODES.LESSON_SPLIT_TYPE
];

export const TEXT_TYPES: string[] = [
    SECTION_TYPE_CODES.LESSON_SPLIT_TYPE,
    SECTION_TYPE_CODES.LESSON_TEXT,
];

export const MESSAGE_EVENT : string = 'message';

export const IFRAME_EVENT_TYPES = {
    resize: 'resize',
    scroll: 'scroll',
    readonly: 'readonly'
}

export const TRANSPARENCY_EVENTS = {
    SCROLL_EVENT: 'TRANSPARENCY_SCROLL_EVENT',
    CHANGE_DOCUMENT_ZOOM: 'CHANGE_DOCUMENT_ZOOM',
    SEND_CURRENT_PAGE_INFO: 'SEND_CURRENT_PAGE_INFO',
    CALL_IFRAME: 'CALL_IFRAME'
}

export const SCROLL_TYPES_BY_OBJECT = {
    [SECTION_TYPE_CODES.LESSON_IMAGES]: 'imagesViewer',
    [SECTION_TYPE_CODES.LESSON_SPLIT_TYPE]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_SPLIT_WRITE]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_PDF]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_DOCX]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_XLS]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_XLSX]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_PPT]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_PPTX]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_DOC]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_MATERIAL]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_TEXT]: 'pdfViewer',
    [MY_CONTENT_TYPES.BOOK]: 'pdfViewer',
    [SECTION_TYPE_CODES.LESSON_EPUB]: 'pdfViewer',
}

export const CLASS_ELEMENTS = {
    [SECTION_TYPE_CODES.LESSON_TEXT]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_IMAGES]: IMAGE_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_SPLIT_TYPE]: TEXT_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_SPLIT_WRITE]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_PDF]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_DOCX]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_XLS]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_XLSX]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_PPT]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_PPTX]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_DOC]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_MATERIAL]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_VIDEO]: VIDEO_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_PPT_HTML]: PPT_HTML_CONTAINER_CLASS,
    [MY_CONTENT_TYPES.BOOK]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_EPUB]: PDF_CONTAINER_CLASS,
    [SECTION_TYPE_CODES.LESSON_CARD]: DECK_CARD_CONTAINER_CLASS,

}
export const SELECTOR_QUERY_ELEMENTS = {
    [PDF_CONTAINER_CLASS]: `#documentId > .ed-file-presentation > .${PDF_CONTAINER_CLASS}`
}

export const INTERNAL_ELEMENT_CLASSES = {
    [SECTION_TYPE_CODES.LESSON_SPLIT_TYPE]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_SPLIT_WRITE]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_PDF]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_DOCX]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_XLS]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_XLSX]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_PPT]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_PPTX]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_DOC]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_MATERIAL]: 'pdf-container__canvas',
    [MY_CONTENT_TYPES.BOOK]: 'pdf-container__canvas',
    [SECTION_TYPE_CODES.LESSON_EPUB]: 'pdf-container__canvas'
}
